<template>
  <section>
    <div class="form-group">
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <label class="inbox-label required">
            {{ t("loan.total_amount") }}
          </label>
          <MoneyInput
            :fieldTitle="t('loan.total_amount', {}, 'zh')"
            fieldname="amount"
            name="amount"
            required
            :value="$store.state.form.applicantInfo.amount"
          />
        </div>
        <div class="col-xs-12 col-sm-6">
          <label class="inbox-label required">{{
            t("lead.question_reason")
          }}</label>
          <v-select
            :options="reasonOptions"
            :reduce="(option) => option.code"
            :searchable="false"
            :fieldTitle="t('lead.question_reason', {}, 'zh')"
            :fieldValue="selectedReason"
            v-model="selectedReason"
            fieldname="reason"
            name="reason"
            required
          />
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <label class="inbox-label required">{{
            t("lead.company_name")
          }}</label>
          <input
            :fieldTitle="t('lead.company_name', {}, 'zh')"
            fieldname="companyName"
            type="text"
            required
            class="form-control"
            name="companyName"
          />
        </div>
        <div class="col-xs-12 col-sm-6">
          <label class="inbox-label required">{{ t("lead.industry") }}</label>
          <v-select
            :options="industries"
            :fieldValue="selectedIndustry"
            v-model="selectedIndustry"
            :reduce="(option) => option.code"
            :searchable="false"
            :fieldTitle="t('lead.industry', {}, 'zh')"
            fieldname="industry"
            label="name"
            required
          />
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <label class="inbox-label required">{{
            t("application.annual_sales_turnover")
          }}</label>
          <MoneyInput
            :fieldTitle="t('application.annual_sales_turnover', {}, 'zh')"
            fieldname="turnover"
            name="turnover"
            value=""
            required
          />
        </div>
        <div class="col-xs-12 col-sm-6">
          <label class="inbox-label required">{{
            t("lead.operation_years")
          }}</label>
          <IntegerInput
            :fieldTitle="t('lead.operation_years', {}, 'zh')"
            :label="t('common.year_unit')"
            fieldname="operationYears"
            required
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import MoneyInput from "~/components/form/MoneyInput.vue";
import IntegerInput from "~/components/form/IntegerInput.vue";
export default {
  name: "Step1",
  components: {
    MoneyInput,
    IntegerInput,
  },
  data: function () {
    return {
      reasonOptions: [],
      industries: [],
      selectedReason: "",
      selectedIndustry: "",
    };
  },
  mounted() {
    this.selectedReason = this.$store.state.form.applicantInfo.reason || "";
    this.reasonOptions = [];
    for (let i = 1; i <= 11; i++) {
      this.reasonOptions.push({
        label: this.t("lead.loan_reason" + i),
        code: this.t("lead.loan_reason" + i, null, "zh"),
      });
    }
    for (let i = 1; i <= 21; i++) {
      this.industries.push({
        name: this.t("lead.industry_option" + i),
        code: this.t("lead.industry_option" + i, null, "zh"),
      });
    }
  },
  methods: {},
};
</script>
